import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/biotimeAreas/${id}?include=employee`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}


// function view(params) {
//     const options = {
//         headers: {
//             'Accept': 'application/vnd.api+json',
//             'Content-Type': 'application/vnd.api+json',
//         }
//     };
//
//     return axios.get(`${url}/biotimeAreas/${params.id}${params.include}`, options)
//
//         .then(response => {
//             let biotimeArea = jsona.deserialize(response.data);
//             delete biotimeArea.links;
//             return biotimeArea;
//         });
// }


function show(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/biotimeAreas/${id}`, options)
        .then(response => {
            let vendors = jsona.deserialize(response.data);
            delete vendors.links;
            return vendors;
        });
}


function list(params) {
    var options = {
        params: params,
        paramsSerializer: function (params) {
            return qs.stringify(params, { encode: false });
        },
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    };

    return axios.get(url + '/biotimeAreas', options)
        .then(function (response) {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta || {}
            };
        });
}

function view(id, config) {
    config = config || {};
    var options = {
        params: {},
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    };
    if (config.include) options.params.include = config.include;

    return axios.get(url + '/biotimeAreas/' + id, options)
        .then(function (response) {
            return jsona.deserialize(response.data);
        });
}

function add(area) {
    var payload = jsona.serialize({
        stuff: area,
        includeNames: null
    });

    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    };

    return axios.post(url + '/biotimeAreas', payload, options)
        .then(function (response) {
            return jsona.deserialize(response.data);
        });
}

function update(area) {
    var payload = jsona.serialize({
        stuff: area,
        includeNames: null
    });

    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    };

    return axios.patch(url + '/biotimeAreas/' + area.id, payload, options)
        .then(function (response) {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    };

    return axios.delete(url + '/biotimeAreas/' + id, options);
}
function syncAreas() {
    var options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json'
        }
    };

    return axios.post(url + '/biotime/areas/syncs', options);
}



export default {
    list,
    get,
    view,
    show,
    add,
    update,
    destroy,
    syncAreas
};

